import { Fragment } from "react";

import Head from "next/head";

import Header from "../../components/Common/Header";
import Footer from "../../components/Common/Footer";
import IndustryWisePage from "../../components/IndustryWisePage";

export const QuicksellForClothing = ({ headerData, headerUseCasesSubMenuData, industryWiseClothingPageData, footerData, geoIp }) => {
  return (
    <Fragment>
      <Head>
        <title>QuickSell | Clothing</title>
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      </Head>
      <Header headerData={headerData} headerUseCasesSubMenuData={headerUseCasesSubMenuData} geoIp={geoIp} />
      <div className="quicksell-page">
        <IndustryWisePage industryWisePageData={industryWiseClothingPageData} geoIp={geoIp} />
        <Footer footerData={footerData} geoIp={geoIp} />
      </div>
    </Fragment>
  );
};

export default QuicksellForClothing;
